import { OperationDataStateMap } from '@uploadcam/common';

import { DeleteOperationLogInteractor } from '../interactors/delete-operation-log.interactor';
import { SetOperationLogStateInteractor } from '../interactors/set-operation-log-state.interactor';

export class OperationLog<T extends keyof OperationDataStateMap> {
  constructor(
    public readonly id: string,
    public readonly type: T,
    private readonly deleteOperationLog: DeleteOperationLogInteractor,
    private readonly setOperationLogState: SetOperationLogStateInteractor,
  ) {}

  public delete(): Promise<void> {
    return this.deleteOperationLog.execute(this);
  }

  public setState(state: OperationDataStateMap[T]): Promise<void> {
    return this.setOperationLogState.execute(this, state);
  }
}
